import {Modal, Button, Row, Form, Col, InputGroup, FloatingLabel, Alert} from 'react-bootstrap';
import React, {useState} from 'react';
import {Link, NavLink, useNavigate} from "react-router-dom";
import { useSanctum } from "react-sanctum";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useAuthLocalStorage} from '../../hooks/useAuthLocalStorage';
import {authLocalStorage, emailADMIN, emailHERO, defaultOTPPSW} from "../../config/global";
import OTPCode from "../modals/OTPCode";
import axios from "axios";
import {toast} from "react-custom-alert";
import {useTranslation} from "react-i18next";
import SubscriptionFlow from "../modals/SubscriptionFlow";

const OTPemailForm = ()  => {

    const { t } = useTranslation();
    const [QRCode, setQRCode] = useState<any>();
    const [showOTPCode, setShowOTPCode] = useState(false);
    const { authenticated, user, signIn, signOut } = useSanctum();
    const navigate = useNavigate();
    const {setAppUniqueToken} = useAppUniqueToken();
    const {setAuthLocalStorageKey} = useAuthLocalStorage();

    const [email, setEmail] = useState('');
    const handleSubmit = (e: any) => {
        //debugger;
        const form = e.currentTarget;
        e.preventDefault();

        let login = '';
        if(email === 'testprofile@test.com' || email === 'otp@otp.com') login = emailADMIN
        else if (email === 'superhero@hero.com') login = emailHERO
        else login = email

        signIn(email, defaultOTPPSW)
            .then((response) => {
                //console.log('signedIn: ' + response.signedIn + ' - twoFactor: '+ response.twoFactor);
                if (response.twoFactor) {
                    /*
                    axios.get('/user/two-factor-qr-code')
                        .then((r) =>{
                            console.log(r);
                            setQRCode(r);
                        })
                    */
                    setShowOTPCode(true);
                    return;
                }
                else
                {
                    axios.post('/user/two-factor-authentication', [], {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }).then(response => {
                        //alert('user/two-factor-authentication:');
                        //alert(response);

                        //console.log('user/two-factor-authentication');
                        //console.log(response);

                    }).catch(error => {
                        //console.log('user/two-factor-authentication');
                        //console.log(error);
                    });

                    signOut();
                    handleSubmit(e);
                }

            })
            .catch(error => {
                //console.log(error);
                toast.error(t('messages.otpRequestFail'));
            });
    };
    const handleOTPCode = () => {
        setShowOTPCode(false);
        //startSubscriptionFlow();
    };

    /*
    const { getAppUniqueToken, removeAppUniqueToken } = useAppUniqueToken();
    
    //const [ uaToken, setuaToken] = useState(getAppUniqueToken);
    const [stockData, setStockData] = useState<any|undefined>();
    const [openStocks, setOpenStocks] = useState<any>();
    const [showSubscriptionFlow, setShowSubscriptionFlow] = useState(false);
    const startSubscriptionFlow = async () => {

        setOpenStocks(undefined);
        setStockData(undefined);

        let k = getAppUniqueToken();

        const payload = {
            k
        };

        let currentSubscriptionFlowObj = await axios.post('api/start', payload)
            .then(res => {

                if(res.data.status)
                {
                    //getUserInfo();
                    //setStockData(res.data);

                    
                    //alert('res.data.stock: ' + JSON.stringify(res.data.stock));
                    setOpenStocks(res.data.stock)
                }
                else
                {
                    removeAppUniqueToken(false);
                    window.location.reload();
                }

            }).catch(err =>
            {
                console.log('startSubscriptionFlow - from axios: ERROR ');
                console.log(err);

                removeAppUniqueToken();
                //toast.error(t('messages.defaultErrorMessage'));
            });
    };

    const handleSubscriptionFlow = () => {

        //setuaToken(getAppUniqueToken());
        setShowSubscriptionFlow(false);

        window.location.reload();
    };
    */

    return (
        <>
        {
/*
<SubscriptionFlow openStocks={openStocks}
                show={showSubscriptionFlow}
                onHide={() => handleSubscriptionFlow()}/>
*/

        }
            
            <OTPCode show={showOTPCode} onHide={() => handleOTPCode()} />
            <Form noValidate onSubmit={handleSubmit}>
                <Row>
                    <Form.Group as={Col} controlId="validationCustomUsername">
                        <FloatingLabel controlId="floatingInput" label="Email address" className="mb-3 text-black">
                            <Form.Control type="email"
                                          size="sm"
                                          placeholder="email"
                                          value={email}
                                          onChange={e => setEmail(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Row>
                <Button className="btn_1 green" onClick={handleSubmit}>
                    {t('captions.startHere')}
                </Button>
            </Form>
        </>
    );
};

export default OTPemailForm;
